"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _default = {
  type: 'percentage',
  LazyComponent: _react["default"].lazy(function () {
    return import('./percentage');
  })
};
exports["default"] = _default;